<!--  -->
<template>
  <div v-if="isShowCoupon">
    <div class="entrance" v-if="couponDetail.couponId" @click="openCouponAcvitity">
      <div class="left">
        <div class="price">{{ couponDetail.discountAmount }}{{ couponDetail.discountType === 1 ? `元` : `折` }}</div>
        <div class="discout" v-if="couponDetail.discountType === 1">满{{ couponDetail.usableCondition }}减{{ couponDetail.discountAmount }}，限时抢券：{{showTime}}</div>
        <div class="discout" v-else>满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折，限时抢券：{{showTime}}</div>
      </div>
      <div class="right">领取</div>
    </div>
    <!-- 优惠券列表 -->
    <CouponList ref="couponList" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CouponList from '../bookComponents/couponList.vue';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';

export default {
  components: {
    CouponList,
  },
  data() {
    return {
       couponDetail: {}, // 最优的优惠券
       showTime: '', // 倒计时
    };
  },
  props:{
    productDetail:{
      type:Object,
      default:()=>{}
    },
    buyStatus:{
      type:Array,
      default:()=>[]
    }
  },
  computed: {
     ...mapState([ 'allAcvitity']),
     isShowCoupon() {
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isRepeatBuy,
        productId,
      } = this.productDetail;
      // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      if (
        status <= 3 ||
        (!isValid && validPeriodType !== 1 && productId) ||
        (isSetStock === 1 && availableStock <= 0) ||
        status === 6 ||
        (this.buyStatus.length && isRepeatBuy === 0)
      ) {
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      let flag = false;
      if (this.couponDetail.couponId) {
        // 优惠卷
        flag = true;
      }
      return flag;
    },
  },
  watch: {
    allAcvitity(data) {
      if (data.couponDetailVO) {
        const idx = 0;
        this.couponDetail = data.couponDetailVO.couponChooseRespList[idx];
        this.countTime();
      }
    },
  },
  methods: {
     openCouponAcvitity() {
      this.$refs.couponList.show = true;
    },
     // 倒计时
    countTime() {
      const { receiveTimeEnd } = this.couponDetail;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp);
        } else {
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.entrance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 678px;
  height: 72px;
  margin: 22px auto 0;
  padding: 16px 24px;
  background: #feeded;
  border-radius: 11px;
  .left {
    display: flex;
    align-items: center;
    .price {
      color: #fe0021;
      font-weight: 500;
      font-size: 29px;
    }
    .discout {
      margin-left: 5px;
      padding-left: 5px;
      color: #fe0021;
      font-weight: 400;
      font-size: 22px;
      border-left: 2px solid #fe0021;
    }
  }
  .right {
    width: 80px;
    height: 51px;
    color: #fff;
    font-weight: 500;
    font-size: 25px;
    line-height: 51px;
    text-align: center;
    background: #fe0021;
    border-radius: 7px;
  }
}
</style>
